import React from 'react';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import { Link } from 'react-router-dom';
import TextareaAutosize from 'react-textarea-autosize';
import Constant from '../../constants';
import api from '../../api';
import Tag from '../Tag';
import './index.css';

export default class DataRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewMode: 'view',
      dataObject: this.props.dataObject,
      shouldHighlight: this.props.shouldHighlight,
      isGrantingPermission: this.props.isGrantingPermission,
      userId: this.props.userId || null,
    };
  }
  changeObjectValue(attribute, value) {
    const { dataObject } = this.state;
    dataObject[attribute] = value;
    this.setState({ dataObject });
  }
  updateObjectPermission(effect='allow', action, isChecked, appliedToAllChild) {
    const { dataObject, userId } = this.state;
    const permissionObject = {
      user_id: userId,
      effect,
      action,
      object_type: dataObject.object_type,
      object_id: dataObject.id,
      applied_to_all_children_object: appliedToAllChild,
    }
    api.fetchAPI({
      method: isChecked ? 'post' : 'delete',
      uri: 'permissions',
      body: permissionObject,
      success: (response) => {
        if (response.status === 'ok') {
          dataObject.permissions[action] = isChecked;
          this.setState({ dataObject });
        } else {
          alert('Error');
          console.log(response);
        }
      },
      error: (error) => {
        console.error(error);
      }
    });
  }
  updateObject() {
    const { dataObject } = this.state;

    let uri = '';
    if (dataObject.object_type === 'table') {
      uri = 'tables';
    } else if (dataObject.object_type === 'database') {
      uri = 'databases';
    } else if (dataObject.object_type === 'field') {
      uri = 'fields';
    }

    api.fetchAPI({
      method: 'put',
      uri,
      body: dataObject,
      success: (response) => {
        if (response.status === 'ok') {
          this.setState({ dataObject: response[dataObject.object_type], viewMode: 'view' });
        } else {
          alert('Error');
          console.log(response);
        }
      },
      error: (error) => {
        console.error(error);
      }
    });
    this.setState({ viewMode: 'view' });
  }
  _buildLink() {
    const { dataObject, isGrantingPermission, userId } = this.state;
    let baseLink = '';

    if (dataObject.object_type === 'field') {
      baseLink = `/table/${dataObject.table_id}/field/${dataObject.id}`;
    } else {
      baseLink = `/${dataObject.object_type}/${dataObject.id}`;
    }

    if (isGrantingPermission && userId) {
      baseLink = `${baseLink}?is_granting_permission=1&user_id=${userId}`;
    }
    
    return baseLink;
  }
  _renderViewMode() {
    const { dataObject, shouldHighlight, isGrantingPermission } = this.state;
    if (!dataObject) return null;
    
    const link = this._buildLink();

    if (!dataObject.data_type) dataObject.data_type = dataObject.object_type;
    
    return (
      <tr className={shouldHighlight ? 'table table-warning' : ''}>
        <td onClick={() => this.setState({ viewMode: dataObject.permissions.edit ? 'edit' : 'view' })}>
          <Link to={link}>
            {dataObject.code_name}
          </Link>
        </td>
        <td>{dataObject.data_type}</td>
        <td style={{ whiteSpace: 'pre-wrap'}}>{dataObject.description}</td>
        {isGrantingPermission &&
          <td>
            {Constant.permissionTypes.map(permissionType => 
              <FormGroup check key={permissionType}>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={dataObject.permissions[permissionType]}
                    onChange={(e) => this.updateObjectPermission('allow', permissionType, e.target.checked, 0)}
                  />{permissionType}
                </Label>
              </FormGroup>
            )}
          </td>
        }
        <td>
          {dataObject.tags && dataObject.tags.map(tag => (
            <Tag key={tag.id} tag={tag} />
          ))}
        </td>
      </tr>
    );
  }
  _renderEditMode() {
    const { dataObject } = this.state;
    if (!dataObject) return null;
    return (
      <tr>
        <td>{dataObject.code_name}</td>
        <td>{dataObject.data_type}</td>
        <td>
          <FormGroup>
            <TextareaAutosize
              className="form-control"
              type="textarea"
              placeholder="Description..."
              value={dataObject.description}
              onChange={(e) => this.changeObjectValue('description', e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Button
              color="success"
              onClick={() => this.updateObject()}
            >
              Save
            </Button>{' '}
            <Button
              color="secondary"
              onClick={() => this.setState({ viewMode: 'view' })}
            >
              Cancel
            </Button>
          </FormGroup>
        </td>
        <td>
          <FormGroup>
            <TextareaAutosize
              className="form-control"
              type="textarea"
              value={dataObject.tag_text}
              onChange={(e) => this.changeObjectValue('tag_text', e.target.value)}
            />
          </FormGroup>
        </td>
      </tr>
    );
  }
  render() {
    const { viewMode } = this.state;
    if (viewMode === 'view') {
      return this._renderViewMode();
    } else {
      return this._renderEditMode();
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/DataRow/index.js